var map = {
	"./app-icon.svg": 1731,
	"./caret-right-icon.svg": 1732,
	"./chrome-icon.webp": 1733,
	"./edge-icon.webp": 1734,
	"./firefox-icon.webp": 1735,
	"./opera-icon.webp": 1736,
	"./safari-icon.webp": 1737,
	"./unknown-icon.webp": 1738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1730;